import data from '@emoji-mart/data';

import ActivitySVG from './assets/activity.svg?raw';
import FlagsSVG from './assets/flags.svg?raw';
import FoodsSVG from './assets/foods.svg?raw';
import FrequentSVG from './assets/frequent.svg?raw';
import NatureSVG from './assets/nature.svg?raw';
import ObjectsSVG from './assets/objects.svg?raw';
import PeopleSVG from './assets/people.svg?raw';
import PlacesSVG from './assets/places.svg?raw';
import SymbolsSVG from './assets/symbols.svg?raw';

export const DEFAULT_SETTINGS = {
  data,
  categoryIcons: {
    activity: {
      svg: ActivitySVG,
    },
    flags: {
      svg: FlagsSVG,
    },
    foods: {
      svg: FoodsSVG,
    },
    frequent: {
      svg: FrequentSVG,
    },
    nature: {
      svg: NatureSVG,
    },
    objects: {
      svg: ObjectsSVG,
    },
    people: {
      svg: PeopleSVG,
    },
    places: {
      svg: PlacesSVG,
    },
    symbols: {
      svg: SymbolsSVG,
    },
  },
  categories: [
    'frequent',
    'people',
    'nature',
    'foods',
    'places',
    'activity',
    'objects',
    'flags',
    'symbols',
  ],
  emojiButtonColors: ['rgba(0,0,0,0.04)'],
  emojiButtonSize: 32,
  emojiSize: 20,
  emojiVersion: 12,
  navPosition: 'top',
  perLine: 9,
  previewPosition: 'none',
  searchPosition: 'sticky',
  set: 'native',
  skin: 1,
  skinTonePosition: 'none',
};
